import { lruMemoize } from 'reselect';

import {
    isResourceLoading,
    isResourceFailed,
    isResourceComplete,
} from './common';

const isCartItemsLoading = lruMemoize(isResourceLoading);
const isCartItemsFailed = lruMemoize(isResourceFailed);
const isCartItemsComplete = lruMemoize(isResourceComplete);

const getCartItemsData = (state) => state.getIn(['app', 'cartItems']);

export {
    isCartItemsLoading,
    isCartItemsFailed,
    isCartItemsComplete,
    getCartItemsData,
};
